"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var Spinner_vue_1 = __importDefault(require("@/components/spinner/Spinner.vue"));
var vue_recaptcha_1 = __importDefault(require("vue-recaptcha"));
var parameters_1 = __importDefault(require("@/config/parameters"));
var CropperImage_vue_1 = __importDefault(require("@/components/cropper-image/CropperImage.vue"));
var ViewWrapper_vue_1 = __importDefault(require("@/components/view-wrapper/ViewWrapper.vue"));
var BaseView_1 = require("../BaseView");
var RegisterAccount = /** @class */ (function (_super) {
    __extends(RegisterAccount, _super);
    function RegisterAccount() {
        var _this = _super.call(this) || this;
        _this.validationState = {
            name: { state: null, message: null },
            surname: { state: null, message: null },
            email: { state: null, message: null },
            password: { state: null, message: null },
            country: { state: null, message: null }
        };
        _this.loader = true;
        _this.formHasErrors = false;
        _this.countriesAvailable = [];
        _this.passwordConfirmation = '';
        _this.agreeTermsAndConditions = false;
        _this.recaptchaConfiguration = parameters_1.default.recaptcha;
        _this.user = {
            email: '',
            name: '',
            surname: '',
            photo: null,
            password: '',
            country: null,
            street: null,
            phone: null,
            city: null,
            gender: null,
            postal_code: null,
            birth_date: null,
            allow_to_receive_newsletters: false
        };
        _this.uploadLoaderImage = false;
        _this.recaptchaSuccessCode = null;
        _this.loaderModalTermsAndConditions = false;
        _this.htmlContentTermsAndConditions = '';
        return _this;
    }
    RegisterAccount_1 = RegisterAccount;
    RegisterAccount.prototype.mounted = function () {
        var _this = this;
        this.$getAllCountriesAvailableService.request().then(function (response) {
            _this.countriesAvailable = response;
            _this.loader = false;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    RegisterAccount.prototype.submit = function () {
        var _this = this;
        this.resetValidationState();
        this.formHasErrors = !this.validation();
        if (this.formHasErrors) {
            return;
        }
        this.loader = true;
        this.$registerService.request(this.user, this.recaptchaSuccessCode).then(function () {
            _this.$router.push({ name: 'createdAccountSuccessfully' });
        }, function (error) {
            if (error.response.status === 409) {
                _this.loader = false;
                _this.formHasErrors = true;
                _this.validationState.email.state = false;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                _this.validationState.email.message = _this.$t('validation.emailInUse');
            }
            else {
                _this.$router.push({ name: 'error', params: { code: error.response.status } });
            }
        });
    };
    RegisterAccount.prototype.validation = function () {
        if (!this.user.name) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.validationState.name.message = this.$t('validation.valueMandatory');
            return this.validationState.name.state = false;
        }
        if (!this.user.surname) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.validationState.surname.message = this.$t('validation.valueMandatory');
            return this.validationState.surname.state = false;
        }
        if (!this.user.email) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.validationState.email.message = this.$t('validation.valueMandatory');
            return this.validationState.email.state = false;
        }
        if (!this.user.password) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.validationState.password.message = this.$t('validation.valueMandatory');
            return this.validationState.password.state = false;
        }
        if (this.user.password.toString().length < RegisterAccount_1.PASSWORD_MINIMUM_CHARACTERS) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.validationState.password.message = this.$t('validation.passwordLength.replace', { number: RegisterAccount_1.PASSWORD_MINIMUM_CHARACTERS });
            return this.validationState.password.state = false;
        }
        if (!this.user.country) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.validationState.country.message = this.$t('validation.valueMandatory');
            return this.validationState.country.state = false;
        }
        if (!new RegExp(RegisterAccount_1.EMAIL_REGEX).test(this.user.email)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.validationState.email.message = this.$t('validation.invalidEmail');
            return this.validationState.email.state = false;
        }
        if (this.passwordConfirmation !== this.user.password) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.validationState.password.message = this.$t('validation.passwordMatch');
            return this.validationState.password.state = false;
        }
        return true;
    };
    RegisterAccount.prototype.resetValidationState = function () {
        this.validationState.name = { state: null, message: null };
        this.validationState.surname = { state: null, message: null };
        this.validationState.email = { state: null, message: null };
        this.validationState.password = { state: null, message: null };
        this.validationState.country = { state: null, message: null };
    };
    RegisterAccount.prototype.onCropSuccessImage = function (file) {
        var _this = this;
        var formData = new FormData();
        formData.append('image', file);
        this.uploadLoaderImage = true;
        this.$uploadCroppedUserImageService.request(formData).then(function (response) {
            _this.user.photo = response;
            _this.uploadLoaderImage = false;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    RegisterAccount.prototype.onCropCancel = function () {
        this.user.photo = null;
    };
    RegisterAccount.prototype.onRecaptchaVerify = function (code) {
        this.recaptchaSuccessCode = code;
    };
    RegisterAccount.prototype.htmlContentTermsAndConditionsHttpRequest = function () {
        var _this = this;
        if (this.htmlContentTermsAndConditions.length) {
            return;
        }
        this.loaderModalTermsAndConditions = true;
        this.$httpService.get(parameters_1.default.cdn.host + "/html/terms-of-use/en/template.html", {}).then(function (response) {
            _this.loaderModalTermsAndConditions = false;
            _this.htmlContentTermsAndConditions = response.data;
        });
    };
    var RegisterAccount_1;
    RegisterAccount.PASSWORD_MINIMUM_CHARACTERS = 6;
    RegisterAccount.EMAIL_REGEX = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    RegisterAccount = RegisterAccount_1 = __decorate([
        vue_property_decorator_1.Component({
            name: 'RegisterAccount',
            components: {
                Spinner: Spinner_vue_1.default,
                VueRecaptcha: vue_recaptcha_1.default,
                CropperImage: CropperImage_vue_1.default,
                ViewWrapper: ViewWrapper_vue_1.default
            },
            metaInfo: function () {
                var title = this.$t("title." + this.$route.name);
                var metaInfo = {
                    title: this.$t('title.default'),
                    titleTemplate: '%s | ' + title,
                    meta: [
                        { name: 'og:title', content: title },
                        { name: 'og:url', content: window.location.href }
                    ],
                    link: [
                        { rel: 'canonical', href: window.location.href }
                    ]
                };
                return metaInfo;
            }
        })
    ], RegisterAccount);
    return RegisterAccount;
}(BaseView_1.BaseView));
exports.default = RegisterAccount;
